import { render, staticRenderFns } from "./SettingsSquadSize.vue?vue&type=template&id=41188a17&"
import script from "./SettingsSquadSize.vue?vue&type=script&lang=js&"
export * from "./SettingsSquadSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports